<template>
<div class="border-top">
  <SOFilterTitle title="Jenis Console" :id="id"/>
  <div class="p-l-24 p-r-24 p-d-24" :id="id">
    <SOInputRadio
      :radios="filter"
      :v2="true"
      :selected-radio="filterItem.jenisSnapConsole"
      @selected="selected"
    />
  </div>
</div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputRadio from "@/so-components/global/input/SOInputRadio";
import {mapGetters} from "vuex";
export default {
  name: "SOFilterSnapConsole",
  components: {SOInputRadio, SOFilterTitle},
  props: {
    id: String
  },
  computed:{
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem"
    })
  },
  data(){
    return {
      filter: [
        {
          label: "Semua",
          name: "jenis-console",
          value: 0,
          id: "0"
        },
        {
          label: "Device",
          name: "jenis-console",
          value: 1,
          id: "1"
        },
        {
          label: "Stack",
          name: "jenis-console",
          value: 2,
          id: "2",
        },
        {
          label: "Group",
          name: "jenis-console",
          value: 3,
          id: "3"
        }
      ]
    }
  },
  methods: {
    selected(payload){
      let temp = this.filterItem
      temp.jenisSnapConsole = payload.value
      this.$store.commit("filterGlobalModule/setFilterItem", temp)
    }
  }
}
</script>

<style scoped>

</style>